import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
    TagsApplicantCount,
    assignEmployerApplicatintsCount,
    employerTagsKey,
    errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useGetEmployerAssignedTagApplicatsProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
    id?: number | null;
};

export const useGetEmployerAssignedTagApplicats = ({
    setErrorText = () => { },
    id,
}: useGetEmployerAssignedTagApplicatsProps) => {
    const { data: assignedApplicantsCount, isFetching: isLoadingCount, } = useQuery<TagsApplicantCount>({
        queryKey: [employerTagsKey, id],
        queryFn: () => {
            const params = new URLSearchParams();

            params.append('tag_id', String(id));

            return axiosInstance
                .get(assignEmployerApplicatintsCount, { params })
                .then((res) => res.data);
        },
        onSuccess: (data) => {
            if (data.status == 200) {
                setErrorText('');
            }
        },
        onError: () => {
            setErrorText(errorMessage);
        },
        refetchOnWindowFocus: false,
        enabled: Boolean(id),
    });

    return {
        assignedApplicantsCount,
        isLoadingCount
    };
};
